import { render } from "./FattureClientiDataTable.vue?vue&type=template&id=276e0ddf&scoped=true"
import script from "./FattureClientiDataTable.vue?vue&type=script&lang=js"
export * from "./FattureClientiDataTable.vue?vue&type=script&lang=js"

import "./FattureClientiDataTable.vue?vue&type=style&index=0&id=276e0ddf&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276e0ddf"]])

export default __exports__